import { render, staticRenderFns } from "./NotesLogs.vue?vue&type=template&id=401ef820"
import script from "./NotesLogs.vue?vue&type=script&lang=js"
export * from "./NotesLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports